import { default as getSelectedSearchScope } from './getSelectedSearchScope';
import getSearchScopeDisplayName from 'owa-mail-search-utils/lib/utils/getSearchScopeDisplayName';
import { SearchScopeKind } from 'owa-search-service/lib/data/schema/SearchScope';
import { getStore } from '../store/store';
import {
    currentFolderScopeLabel,
    recursiveFolderScopeLabel,
    allMailboxesScopeLabel,
    allPstFilesScopeLabel,
} from './getSelectedSearchScopeDisplayName.locstring.json';
import loc from 'owa-localize';
import getIsCurrentFolderScope from '../selectors/getIsCurrentFolderScope';
import getIsSubfolderScope from '../selectors/getIsSubfolderScope';

export default function getSelectedSearchScopeDisplayName(): string | null {
    const store = getStore();

    if (!store.initialSearchScope) {
        return null;
    }

    // Check if "Current Folder" is selected
    if (getIsCurrentFolderScope()) {
        return loc(currentFolderScopeLabel);
    }

    // Check if "Subfolders" is selected
    if (getIsSubfolderScope()) {
        return loc(recursiveFolderScopeLabel);
    }

    // Check if "All mailboxes" is selected
    if (store.staticSearchScope?.kind === SearchScopeKind.AllMailboxes) {
        return loc(allMailboxesScopeLabel);
    }

    if (store.staticSearchScope?.kind === SearchScopeKind.AllPstFiles) {
        return loc(allPstFilesScopeLabel);
    }

    const selectedSearchScope = getSelectedSearchScope();
    const selectedFolderScope = getSearchScopeDisplayName(
        selectedSearchScope,
        getStore().selectedMailboxInfo,
        true /* isSearchFromFolderScope*/
    );

    return selectedFolderScope;
}
